export class ResetPasswordModel {
  public UserName: string = '';
  public Token: string = '';
  public NewPassword: string = '';
}